import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { getAllOrders } from "../../redux/apiCall/orderCall.jsx";
import AdminLayout from "../components/AdminLayout";
import TableOrder from "../components/TableOrder";

const AdminOrder = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getAllOrders());
  }, [dispatch]);

  return (
    <AdminLayout title="Orders" stats="orders">
      <TableOrder />
    </AdminLayout>
  );
};

export default AdminOrder;
